import { Routes, Route, Navigate, useParams } from "react-router-dom";

import { AppShell } from "./components/AppShell";
import { LandingPage } from "./pages/LandingPage";
import { DonesiPage } from "./pages/DonesiPage";
import { ProvjeriPage } from "./pages/ProvjeriPage";
import { DocsPage } from "./pages/DocsPage";
import { PostavkePage } from "./pages/PostavkePage";
import { FeasibilityCheckPage } from "./pages/FeasibilityCheckPage";
import { RadarPage } from "./pages/RadarPage";
import { KitchenPage } from "./pages/KitchenPage";

/** Legacy redirect: the project flow used to be /data (one scroll) + /docs.
 * It's now Donesi → Provjeri → Preuzmi. Old links and persisted drafts still
 * point at the old paths, so redirect instead of 404-ing them. */
function LegacyRedirect({ to }: { to: "donesi" | "preuzmi" }) {
  const { projectId } = useParams();
  return <Navigate to={`/project/${projectId}/${to}`} replace />;
}

export function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/provjera" element={<FeasibilityCheckPage />} />
        <Route path="/radar" element={<RadarPage />} />
        <Route path="/postavke" element={<PostavkePage />} />

        {/* Generation flow — one job per screen, one CTA per screen. */}
        <Route path="/project/:projectId/donesi" element={<DonesiPage />} />
        <Route path="/project/:projectId/provjeri" element={<ProvjeriPage />} />
        <Route path="/project/:projectId/preuzmi" element={<DocsPage />} />

        {/* Legacy paths → new flow. */}
        <Route
          path="/project/:projectId/data"
          element={<LegacyRedirect to="donesi" />}
        />
        <Route
          path="/project/:projectId/feasibility"
          element={<LegacyRedirect to="donesi" />}
        />
        <Route
          path="/project/:projectId/docs"
          element={<LegacyRedirect to="preuzmi" />}
        />

        <Route path="/_kitchen" element={<KitchenPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
